/* Alpine and First Party Plugins */
import Alpine from 'alpinejs'
import Splide from '@splidejs/splide'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'

/* Custom Alpine modules */
import header from './alpine/_header'
import clip from './alpine/components/_clip'
import gallery from './alpine/blocks/_gallery'
import testimonials from './alpine/blocks/_testimonials'
import projectSlider from './alpine/blocks/_project-slider'
import fade from './alpine/components/_fade.js'

Alpine.plugin(fade);
Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.plugin(intersect)

Alpine.store('header', header);

Alpine.data('clip', clip);
Alpine.data('gallery', gallery);
Alpine.data('testimonials', testimonials);
Alpine.data('projectSlider', projectSlider);

window.Alpine = Alpine
window.Splide = Splide